import { ServerError } from "../models/serverError";

export type CommonStore = {
  error: ServerError | null;
  token: string | null;
  appLoaded: boolean;
  setServerError: (error: ServerError) => void;
  setToken: (token: string | null) => void;
  setAppLoaded: () => void;
};

export const createCommonStore = (set: any, _get: any): CommonStore => ({
  error: null,
  token: localStorage.getItem("jwt"),
  appLoaded: false,

  setServerError: (error: ServerError) =>
    set((state: any) => ({
      commonStore: { ...state.commonStore, error },
    })),

  setToken: (token: string | null) => {
    if (token) localStorage.setItem("jwt", token);
    else localStorage.removeItem("jwt");
    set((state: any) => ({
      commonStore: { ...state.commonStore, token },
    }));
  },

  setAppLoaded: () =>
    set((state: any) => ({
      commonStore: { ...state.commonStore, appLoaded: true },
    })),
});